import Vue from 'vue';
export const FontSizeScale = {
  // 初始化指令
  inserted(el, binding, vnode) {
    let value = binding.value
    el.style.whiteSpace = `nowrap`
    Vue.prototype.$nextTick(() => {
      let span = document.createElement('div')
      span.innerText = el.innerText
      span.style.position = 'absolute'
      span.style.top = '-9999px'
      span.style.whiteSpace = 'nowrap'
      span.style.fontSize = '12px'
      document.body && document.body.appendChild(span)

      el.style.marginRight = - span.clientWidth * (1 - value) + 'px'
      el.style.transform = `scale(${value})`
      el.style.transformOrigin = `left`

      document.body && document.body.removeChild(span)
    })
  },
  update(el, binding) {
    let value = binding.value
    el.style.whiteSpace = `nowrap`
    Vue.prototype.$nextTick(() => {
      let span = document.createElement('div')
      span.innerText = el.innerText
      span.style.position = 'absolute'
      span.style.top = '-9999px'
      span.style.whiteSpace = 'nowrap'
      span.style.fontSize = '12px'
      document.body && document.body.appendChild(span)

      el.style.marginRight = - span.clientWidth * (1 - value) + 'px'
      el.style.transform = `scale(${value})`
      el.style.transformOrigin = `left`

      document.body && document.body.removeChild(span)
    })
  }
}
